export const MAX_VIDEO_FILE_SIZE: number = 100971520